<template>
  <div>

    <CRow>
      <CCol lg="12">
        <CCard>
        <CCardHeader>
          <slot name="header">
            <!-- <CIcon name="cil-grid"/> --><h4 class="float-left">Data Rubrik</h4> 
            <a href="#/rubrik/add" class="float-right btn btn-success form-control-sm">Tambah Rubrik</a>

          </slot>
        </CCardHeader>
        <CCardBody>
      
        <table class="table" id="datatable">
          <thead>
            <tr>
              <th style="width:30px">#</th>
              <th>Nama Rubrik/Kanal</th>
              <th style="width:70px">Urutan</th>
              <th style="width:70px">Status</th>
              <th style="width:50px">Edit</th>
            </tr>
          </thead>
          <tbody>

          </tbody>
        </table>  

    </CCardBody>
  </CCard>  
  
  </CCol>
    </CRow>
  </div>
</template>
 
<script>
import 'jquery/dist/jquery.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from 'axios';
import $ from 'jquery'; 



export default {
  // methods: {
  //   numberWithCommas(x) {
  //       return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  //   }
  // },
  filters: {
    rupiah: function(value) {
      // return value.toUpperCase();
      // Create our number formatter.
      var formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(value); /* $2,500.00 */
    }
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2019}, (value, index) => new Date().getFullYear() - index)
    }
  },
  mounted(){
    console.log(process.env.VUE_APP_BASE_URL);
    this.loadData();
    let us = JSON.parse(this.$store.state.users);
      // alert(us.name);
      if(us.level=='1'){
        this.add= true;
      }
  },
  data: function() {
        return {
            products:[],
            items:[],
            add:false,
            itemlengths:0,
            tahun: new Date().getFullYear(),
        }
  },
  methods: {
    loadData: function() {
               
          axios
        .post(
          process.env.VUE_APP_BASE_URL+"api/public/index.php/template/?key=$2y$10$AnZ411EfYcBHTEMMYbXni.7HuKm5nf4fCleVEKMPs9dsDRKlrLCPu",false
        )
        .then((response) => {
          this.items=response.data.data;
          this.itemlengths = this.items.length;

          // alert(JSON.stringify(this.items));
        });
      if (this.tahun == null){
      // your code here.
        // axios
        // .get("https://probowsolution.com/sippd/api/public/index.php/User/2021?key=704b037a97fa9b25522b7c014c300f8a")
        // .then((response)=>
        // {
          // this.products = response.data;
          $('#datatable').DataTable({
            "processing": true,
              "serverSide": true,
               "pageLength": 50,
              "ajax":{
                       "url": process.env.VUE_APP_BASE_URL+"rubrik/datatable",
                       "dataType": "json",
                       "type": "POST"
                     },
              "columns": [
                  { "data": "no" },
                  { "data": "name" },
                  { "data": "position" },
                  { "data": "status" },
                  { "data": "edit", class:"text-center" },
              ]  

          });
          
          $.fn.dataTableExt.sErrMode = 'throw';
          
        // })
      }
      else{
        // axios
        // .get("https://probowsolution.com/sippd/api/api/public/index.php/User/"+this.tahun+"?key=704b037a97fa9b25522b7c014c300f8a")
        // .then((response)=>
        // {
        //   this.products = response.data;
          $('#datatable').DataTable({
                      "processing": true,
              "serverSide": true,
               "pageLength": 50,
              "ajax":{
                       "url": process.env.VUE_APP_BASE_URL+"rubrik/datatable",
                       "dataType": "json",
                       "type": "POST"
                     },
              "columns": [
                  { "data": "no" },
                  { "data": "name" },
                  { "data": "position" },
                  { "data": "status" },
                  { "data": "edit", class:"text-center" },
              ]  
          
 
          });
          
          $.fn.dataTableExt.sErrMode = 'throw';
          
        // })
      }
      
    }
  }
}
</script>